import { useState } from "react";
import { Result } from "../interfaces";

interface ActiveDescendantHandler {
  activeDescendant: string;
  setInitialActiveDescendant: () => void;
  unsetActiveDescendant: () => void;
  setNextActiveDescendant: () => void;
  setPreviousActiveDescendant: () => void;
}

export const useActiveDescendant = (
  options: Result[],
): ActiveDescendantHandler => {
  const [activeDescendant, setActiveDescendant] = useState("");

  const findSelectedIndex = (): number =>
    options.findIndex(({ value }) => value === activeDescendant);

  const setInitialActiveDescendant = (): void => {
    setActiveDescendant(options[0]?.value ?? "");
  };

  const unsetActiveDescendant = (): void => {
    setActiveDescendant("");
  };

  const setNextActiveDescendant = (): void => {
    const selectedIndex = findSelectedIndex();
    if (selectedIndex !== -1 && selectedIndex < options.length - 1) {
      setActiveDescendant(options[selectedIndex + 1].value);
    }
  };

  const setPreviousActiveDescendant = (): void => {
    const selectedIndex = findSelectedIndex();
    if (selectedIndex > 0) {
      setActiveDescendant(options[selectedIndex - 1].value);
    }
  };

  return {
    activeDescendant,
    unsetActiveDescendant,
    setInitialActiveDescendant,
    setNextActiveDescendant,
    setPreviousActiveDescendant,
  };
};
